import UpdatePaymentMethodFlex from './UpdatePaymentMethodFlex';

export default UpdatePaymentMethodFlex;
